import { type FC, type ReactElement, type ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import dibsCss from 'dibs-css';

type FollowSearchProps = {
    searchName: string;
    searchNameClassname?: string;
};

export const FollowSearch: FC<FollowSearchProps> = ({ searchName, searchNameClassname }) => (
    <FormattedMessage
        id="global.followSearch"
        defaultMessage="Follow {searchName} to receive alerts when new items arrive"
        values={{
            searchName: <span className={searchNameClassname || ''}>{searchName}</span>,
        }}
    />
);

export const moreDetails = (
    <FormattedMessage id="global.moreDetails" defaultMessage="More Details" />
);
export const seeLess = <FormattedMessage id="abf.global.seeLess.copy" defaultMessage="See Less" />;

export const viewSimilarItems = (
    <FormattedMessage id="global.viewSimilarItems" defaultMessage="View Similar Items" />
);

export const moreFromThisSeller = (
    <FormattedMessage id="global.moreFromThisSeller" defaultMessage="More From This Seller" />
);

export const moreSimilarItems = (
    <FormattedMessage
        id="pdp.infiniteScroll.moreSimilarItems"
        defaultMessage="More Similar Items"
    />
);

export const diveBackIntoYourFavorites = (
    <FormattedMessage
        id="abf.PdpSharedRecentlyFavoritedCarousel.diveBackIntoYourFavorites"
        defaultMessage="Dive Back Into Your Favorites"
    />
);

type ItemsSimilarToHeaderProps = {
    title: ReactElement;
};

export const ItemsSimilarToHeader: FC<ItemsSimilarToHeaderProps> = ({ title }) => (
    <FormattedMessage
        values={{ title }}
        id="global.itemsSimilarToHeader"
        defaultMessage="Items Similar to {title}"
    />
);

export const viewAll = (
    <FormattedMessage id="pdp.PdpMobileDealerItems.view_all" defaultMessage="View All" />
);
export const viewYourFavorites = (
    <FormattedMessage
        id="abf.PdpSharedRecentlyFavoritedCarousel.viewYourFavorites"
        defaultMessage="View Your Favorites"
    />
);

export const favoritesTitle = (
    <FormattedMessage
        id="abf.PdpSharedFeedCarousel.aFewOfYourFavoriteThings"
        defaultMessage="A Few of <italic>Your Favorite Things</italic>"
        values={{
            italic: (chunks: ReactNode) => (
                <span className={dibsCss.sassyFontHeaderNoneItalic}>{chunks}</span>
            ),
        }}
    />
);

export const recentlyViewedTitle = ({ isMobile }: { isMobile: boolean }): ReactElement =>
    isMobile ? (
        <FormattedMessage
            id="abf.PdpSharedFeedCarousel.stillThinking"
            defaultMessage="Still Thinking?"
        />
    ) : (
        <FormattedMessage
            id="abf.PdpSharedFeedCarousel.stillThinkingRecentlyViewed"
            defaultMessage="Still Thinking? <italic>Your Recently Viewed Items</italic>"
            values={{
                italic: (chunks: ReactNode) => (
                    <span className={dibsCss.sassyFontHeaderNoneItalic}>{chunks}</span>
                ),
            }}
        />
    );

export const startConversationMessage = (
    <FormattedMessage id="global.starConversation" defaultMessage="Ask the Seller" />
);

export const messageSeller = (
    <FormattedMessage id="global.messageSeller" defaultMessage="Message the Seller" />
);

export const itemStatus = <FormattedMessage id="global.itemStatus" defaultMessage="Item Status:" />;

export const sellerInformation = (
    <FormattedMessage id="global.sellerInformation" defaultMessage="Seller Information" />
);

export const buyerIncentives = (
    <FormattedMessage id="global.buyerIncentives" defaultMessage="The 1stDibs Promise" />
);

export const itemDetails = (
    <FormattedMessage id="global.itemDetails" defaultMessage="Item Details" />
);

export const itemDescriptionAndSpecifications = (
    <FormattedMessage
        id="abf.PdpRespDetailAccordions.itemDescriptionAndSpecifications"
        defaultMessage="Item Description & Specifications"
    />
);

export const itemDescription = (
    <FormattedMessage
        id="abf.PdpMobileDetailAccordions.itemDescription"
        defaultMessage="Item Description"
    />
);

export const itemSpecifications = (
    <FormattedMessage
        id="abf.PdpMobileDetailAccordions.itemSpecifications"
        defaultMessage="Item Specifications"
    />
);

export const dimensionUnitAriaLabel = {
    id: 'abf.PdpDimensionUnitToggle.dimensionUnit',
    defaultMessage: 'Dimension unit',
};

export const moreItems = <FormattedMessage id="global.moreItems" defaultMessage="More Items" />;
export const shippingAndReturns = (
    <FormattedMessage id="global.shippingAndReturns" defaultMessage="Shipping & Returns" />
);
export const customization = (
    <FormattedMessage id="global.customization" defaultMessage="Customization" />
);

export const priceEstimatePill = ({
    isBelowMinPriceEstimate,
}: {
    isBelowMinPriceEstimate: boolean;
}): ReactElement => (
    <FormattedMessage
        id="global.priceEstimatePill"
        defaultMessage="{isBelowMinPriceEstimate, select, true {Well Priced} other {Competitively Priced}}"
        values={{ isBelowMinPriceEstimate }}
    />
);

export const similarSoldItemsPriceVariationExplanation = (
    <FormattedMessage
        id="global.priceVariationExplanation"
        defaultMessage="Prices may vary based on factors above as well as rarity, provenance, and restoration quality."
    />
);
